<template>
    <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-100">
            <thead class="bg-gray-50">
                <tr>
                    <SortableTh :label="t('vue.id')" field="id" />
                    <SortableTh :label="t('vue.kiosk_da_user')" field="name" />
                    <SortableTh :label="t('vue.email')" field="email" />
                    <SortableTh :label="t('vue.kiosk_da_time')" field="time" />
                    <th
                        class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500"
                    />
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
                <tr
                    v-for="item in items"
                    :key="item.id"
                    class="hover:bg-gray-50/60"
                >
                    <td class="px-4 py-3 font-mono text-xs text-gray-400">
                        {{ item.id }}
                    </td>
                    <td class="px-4 py-3 text-sm font-medium text-gray-900">
                        <div class="flex items-center gap-2">
                            <div
                                class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full"
                                :class="
                                    isVerified ? 'bg-green-100' : 'bg-blue-100'
                                "
                            >
                                <CheckBadgeIcon
                                    v-if="isVerified"
                                    class="h-3.5 w-3.5 text-green-600"
                                />
                                <UserPlusIcon
                                    v-else
                                    class="h-3.5 w-3.5 text-blue-600"
                                />
                            </div>
                            {{ item.name }}
                        </div>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        {{ item.email ?? "—" }}
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        {{ item.time ?? "—" }}
                    </td>
                    <td class="px-4 py-3 text-right text-sm text-gray-600">
                        <AdminLink :href="item.kiosk_url" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts" setup>
import { CheckBadgeIcon, UserPlusIcon } from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";
import type { IUserItem } from "../../types";

const { t } = useTranslations();

defineProps<{
    items: IUserItem[];
    isVerified: boolean;
}>();
</script>
